import { LinearGradient } from "expo-linear-gradient";
import { ReactNode } from "react";
import { Platform, StyleProp, ViewStyle } from "react-native";
import { STICKER_SELECTION } from "src/api/featureFlags";
import ImpactBackgroundGradient from "src/components/ImpactBackgroundGradient";
import { DEFAULT_IMPACT_BACKGROUND_GRADIENT } from "src/components/ImpactBackgroundGradient/constants";
import Touchable from "src/components/Touchable";
import cursor from "src/constants/cursor";
import native from "src/constants/native";
import { ThemeOptionItem } from "src/screens/(internal)/CustomThemeModal/types";
import { paddingSmall } from "src/styles/spacing";
import { Image } from "src/swsh-native";
import { FLOATING_THEME_MENU_ITEM_SIZE } from "../constants";

const PADDING = paddingSmall;
const INNER_SIZE = FLOATING_THEME_MENU_ITEM_SIZE - 2 * PADDING;
const FloatingThemeOption = ({
	suggestion,
	style,
	onPress,
	children,
}: {
	suggestion: ThemeOptionItem & { isSelected: boolean };
	style?: StyleProp<ViewStyle>;
	onPress?: (
		suggestion: ThemeOptionItem & {
			isSelected: boolean;
		},
	) => void;
	children?: ReactNode;
}) => {
	if (!suggestion.palette) return null;
	const { primary, secondary, tertiary } = suggestion.palette;
	const stickerThumbnailUrl = suggestion.stickerPack?.thumbnailUrl;
	if (!primary || !secondary || !tertiary) return null;
	return (
		<Touchable
			testID="ThemeOption"
			containerStyle={{
				width: FLOATING_THEME_MENU_ITEM_SIZE,
				height: FLOATING_THEME_MENU_ITEM_SIZE,
				borderRadius: FLOATING_THEME_MENU_ITEM_SIZE / 2,
				cursor: cursor.pointer,
			}}
			onPress={() => {
				onPress?.(suggestion);
			}}
		>
			<ImpactBackgroundGradient
				{...(suggestion.isSelected
					? DEFAULT_IMPACT_BACKGROUND_GRADIENT
					: {
							palette: suggestion.palette,
						})}
				style={[
					style,
					{
						alignItems: "center",
						justifyContent: "space-between",
						width: FLOATING_THEME_MENU_ITEM_SIZE,
						height: FLOATING_THEME_MENU_ITEM_SIZE,
						borderRadius: FLOATING_THEME_MENU_ITEM_SIZE / 2,
						padding: PADDING,
					},
				]}
			>
				<LinearGradient
					style={{
						width: INNER_SIZE,
						height: INNER_SIZE,
						borderRadius: INNER_SIZE / 2,
						backgroundColor: suggestion.palette?.primary ?? undefined,
						alignItems: "center",
						justifyContent: "center",
					}}
					colors={[
						secondary,
						primary,
						`${tertiary}${native && Platform.OS === "ios" ? `30` : `60`}`,
					]}
					locations={[0, 0.55, 1]}
					start={{
						x: 0.2,
						y: 0,
					}}
					end={{
						x: 0.6,
						y: 1,
					}}
				>
					{!!children ? (
						children
					) : STICKER_SELECTION && !!stickerThumbnailUrl ? (
						<>
							<Image
								alt="Sticker"
								src={stickerThumbnailUrl}
								dim={{
									width: 0.6 * INNER_SIZE,
									height: 0.6 * INNER_SIZE,
								}}
								style={{
									transform: [{ rotate: "-10deg" }],
								}}
								contentFit="contain"
							/>
						</>
					) : null}
				</LinearGradient>
			</ImpactBackgroundGradient>
		</Touchable>
	);
};
export default FloatingThemeOption;
